import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MyPromise } from '../interceptors/myPromise.service';

const ANNUAL_PROGRAM_BASE_API_URL = `${environment.baseEndpoint}/annualProgram`;
const DEFAULT_ANNUAL_PROGRAM_BASE_API_URL = `${environment.baseEndpointPHP}`;
const URL_PHP = `${environment.baseEndpointPHP}`;

@Injectable({
  providedIn: 'root',
})
export class AnnualProgramService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  getAnnualProgramNewCatalog () {
    return this.myPromise.to(this.http.get(`${URL_PHP}/program-annual/catalog`));
  }

  getCatalogEvents() {
    return this.myPromise.to(this.http.get(`${URL_PHP}/events`));
  }

  getStationEvents(stationId: string) {
    return this.myPromise.to(this.http.get(`${ANNUAL_PROGRAM_BASE_API_URL}/${stationId}/event`));
  }

  storeEvent(stationId: any, event: any) {
    return this.myPromise.to(this.http.post(`${ANNUAL_PROGRAM_BASE_API_URL}/${stationId}/event`, event));
  }

  updateEvent(stationId: string, id: string, data: any) {
    return this.myPromise.to(this.http.put(`${ANNUAL_PROGRAM_BASE_API_URL}/${stationId}/event/${id}`, data));
  }

  deleteEvent(stationId: string, id: string) {
    return this.myPromise.to(this.http.delete(`${ANNUAL_PROGRAM_BASE_API_URL}/${stationId}/event/${id}`));
  }

  update(stationId: string, logbook: any) {
    return this.myPromise.to(this.http.put(`${ANNUAL_PROGRAM_BASE_API_URL}/${logbook.id}/station/${stationId}`, logbook));
  }

  getPreferences(stationId: string) {
    return this.myPromise.to(this.http.get(`${ANNUAL_PROGRAM_BASE_API_URL}/station/${stationId}/preferences`));
  }

  storePreferences(stationId: string, preferences: Array<object>) {
    return this.myPromise.to(this.http.post(`${ANNUAL_PROGRAM_BASE_API_URL}/station/${stationId}/preferences`, { preferences }));
  }

  getDefaultEvents(stationId) {
    return this.myPromise.to(this.http.get(`${DEFAULT_ANNUAL_PROGRAM_BASE_API_URL}/default-annual-events/${stationId}`));
  }

  async getDefaultCleaningEvents(stationId) {
    const [error, { data }] = await this.myPromise.to(this.http.get(`${DEFAULT_ANNUAL_PROGRAM_BASE_API_URL}/default-annual-cleaning-events/${stationId}`));
    if (error) {
      return [error]
    }

    const [_error, _data] = await this.myPromise.to(this.http.get('assets/data/cleaning-events.json'));

    let dataFormated = _data.map(el => {
      return {
        default_event_checked: data.includes(el.id),
        ...el
      }
    })

    return [null, dataFormated]
  }
}
